export default "__VITE_ASSET__DUkqAUV7__"